import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 0.3rem;

  margin-bottom: 1rem;

  position: relative;

  padding: 1rem;

  > p {
    font-size: 1rem;

    position: absolute;
    top: -0.9rem;

    background: #fff;

    padding: 0 0.5rem;

    color: #999;
  }

  > ul {
    box-shadow: none;
  }
`;
